import { Component } from '@angular/core';

@Component({
  selector: 'app-instagram-baner',
  templateUrl: './instagram-baner.component.html',
  styleUrls: ['./instagram-baner.component.scss']
})
export class InstagramBanerComponent {

}
